module.exports = __webpack_public_path__ + "static/media/file_remarks_description_report.6db95482.svg";